import type { TransportBroadcast, TransportCommandType, TransportInstruction } from './types';

export function processTransportCommand(
  command: TransportCommandType,
  broadcast: TransportBroadcast,
): TransportInstruction {
  switch (command) {
    case 'play':
      return {
        type: 'play',
        timeMs: broadcast.timeMs ?? 0,
        sectionIndex: broadcast.sectionIndex ?? 0,
      };
    case 'pause':
      return {
        type: 'pause',
        timeMs: broadcast.timeMs ?? 0,
        sectionIndex: broadcast.sectionIndex ?? 0,
      };
    case 'seek':
      return {
        type: 'seek',
        timeMs: broadcast.timeMs ?? 0,
        sectionIndex: broadcast.sectionIndex ?? 0,
      };
    case 'reset':
      return { type: 'reset' };
  }
}
